import React from 'react';
import Dialog from 'components/dialog';

const RefuelingProcessingDialog = ({ isShow }) => {
  return (
    <Dialog
      isShow={isShow}
      title={'付款中，請稍候...'}
      message={'正在與銀行取得授權中，為了您的交易安全，請耐心等待約 10 秒，交易馬上就完成囉！'}
    />
  );
};

export default RefuelingProcessingDialog;
